import { render, staticRenderFns } from "./DeletedResources.vue?vue&type=template&id=79de8486&"
import script from "./DeletedResources.vue?vue&type=script&lang=js&"
export * from "./DeletedResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports